module.exports = __webpack_public_path__ + "static/media/tali_taaa.87fbef07.ogg";